var paragraph_default = {
  "fontElementMap": "iOiSp",
  "elementSpacing": "wRZQq",
  "text": "_18IfL wRZQq",
  "child": "UWvBg"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
